import localFont from "next/font/local";
import React from "react";

const SFProDisplayRegular = localFont({
  src: "../public/fonts/SFPro-Display-Regular.woff2",
  display: "swap",
  variable: "--sfpro-display-regular",
});
const SFProDisplayMedium = localFont({
  src: "../public/fonts/SFPro-Display-Medium.woff2",
  display: "swap",
  variable: "--sfpro-display-medium",
});
const SFProDisplayBold = localFont({
  src: "../public/fonts/SFPro-Display-Bold.woff2",
  display: "swap",
  variable: "--sfpro-display-bold",
});
const SFProDisplayHeavy = localFont({
  src: "../public/fonts/SFPro-Display-Heavy.woff2",
  display: "swap",
  variable: "--sfpro-display-heavy",
});
/**
 * Single SF Pro Display family with all weights registered correctly.
 * Lets `font-weight: 700` (etc.) actually select the right face — unlike the
 * per-weight exports above, which each live in their own family with no weight
 * descriptor. Mirrors `apps/web/components/fonts.ts`.
 */
const SFProDisplay = localFont({
  src: [
    {
      path: "../public/fonts/SFPro-Display-Regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "../public/fonts/SFPro-Display-Medium.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "../public/fonts/SFPro-Display-Bold.woff2",
      weight: "700",
      style: "normal",
    },
    {
      path: "../public/fonts/SFPro-Display-Heavy.woff2",
      weight: "900",
      style: "normal",
    },
  ],
  display: "swap",
  variable: "--sfpro-display",
});
const EKModenaExtendedHeavy = localFont({
  src: "../public/fonts/EKModenaExtended-Heavy.woff2",
  display: "swap",
  variable: "--ek-modena-extended-heavy",
});

export const FontProvider = ({ children }) => {
  return (
    <>
      <style jsx global>{`
        html {
          --sfpro-display-regular: ${SFProDisplayRegular.style.fontFamily};
          --sfpro-display-medium: ${SFProDisplayMedium.style.fontFamily};
          --sfpro-display-bold: ${SFProDisplayBold.style.fontFamily};
          --sfpro-display-heavy: ${SFProDisplayHeavy.style.fontFamily};
          --sfpro-display: ${SFProDisplay.style.fontFamily};
          --ek-modena-extended-heavy: ${EKModenaExtendedHeavy.style.fontFamily};
        }
      `}</style>
      {children}
    </>
  );
};
